import { render, staticRenderFns } from "./FilmPlatform.vue?vue&type=template&id=91fa3fa2"
import script from "./FilmPlatform.vue?vue&type=script&lang=js"
export * from "./FilmPlatform.vue?vue&type=script&lang=js"
import style0 from "./FilmPlatform.vue?vue&type=style&index=0&id=91fa3fa2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports